module.exports = __webpack_public_path__ + "img/SketchPngb17dd239cffd06088911896759bc7f35dfb992d99d5da28c6ef6b38b9c80cc61.56b3439e.png";